import {ApiErrorHandler} from './ApiErrorHandler';

/**
 * Returns field errors with field name property as key and message as value
 */
export class FormFieldError<
  FieldErrors = Record<string, string>,
> extends ApiErrorHandler<FieldErrors> {
  getFieldErrors(): FieldErrors {
    return this.apiErrors.reduce((fieldErrors, apiError) => {
      if (apiError.field) {
        fieldErrors[apiError.field] = apiError.message;
      } else {
        console.debug('Missing field property', apiError);
      }

      return fieldErrors;
    }, {} as FieldErrors);
  }

  getMappedFieldErrors(fieldMap: Record<string, string> = {}): FieldErrors {
    const fieldErrors = this.getFieldErrors();
    Object.keys(fieldMap).forEach((oldName) => {
      if (fieldErrors[oldName]) {
        const newFieldName = fieldMap[oldName];
        fieldErrors[newFieldName] = fieldErrors[oldName];
        delete fieldErrors[oldName];
      }
    });

    return fieldErrors;
  }
}
